module.exports = __webpack_public_path__ + "img/Type=NL Compact, Color=Navy.53b0277a.svg";